import '../../assets/css/case-home.css';
import '../../assets/css/case-property.css';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';
import cornerIcon from '../../assets/images/case-image-corner.svg';

export function CareersEmployees() {
  const empLabel = useContentToken('careersemployees.emp_label');
  const empTitle = useContentToken('careersemployees.emp_title');
  const empCtaText1 = useContentToken('careersemployees.emp_cta_text_1');
  const empCtaUrl1 = useContentToken('careersemployees.emp_cta_url_1');
  const empCtaText2 = useContentToken('careersemployees.emp_cta_text_2');
  const empCtaUrl2 = useContentToken('careersemployees.emp_cta_url_2');
  const empImage0 = useContentToken('careersemployees.emp_image_0');
  const empImage1 = useContentToken('careersemployees.emp_image_1');
  const empImage2 = useContentToken('careersemployees.emp_image_2');

  const belLabel = useContentToken('careersemployees.bel_label');
  const belTitle = useContentToken('careersemployees.bel_title');
  const belImage = useContentToken('careersemployees.bel_image');

  return (
    <section className="case-careerspage-employees">
      <div className="case-container">
        {/* Our Employees section */}
        <div className="case-careerspage-employees-section">
          <div className="case-careerspage-grid">
            <div className="case-careerspage-employees-text">
              <EditableToken path="careersemployees.emp_label" type="text" label="Section Label" defaultValue={contentSchema.tokens['careersemployees.emp_label'].defaultValue} as="h4" style={{ fontSize: '1.125rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.5rem', letterSpacing: '0.05em' }}>
                {empLabel}
              </EditableToken>
              <EditableToken path="careersemployees.emp_title" type="text" label="Section Title" defaultValue={contentSchema.tokens['careersemployees.emp_title'].defaultValue} as="h2" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)', fontWeight: 700, marginBottom: '1.5rem' }}>
                {empTitle}
              </EditableToken>
              <RichTextContent
                path="careersemployees.emp_body"
                label="Body Text"
                defaultValue={contentSchema.tokens['careersemployees.emp_body'].defaultValue}
                as="div"
                style={{ lineHeight: 1.6 }}
              />
              <div className="case-careerspage-cta-buttons">
                <EditableToken path="careersemployees.emp_cta_url_1" type="url" label="CTA 1 URL" defaultValue={contentSchema.tokens['careersemployees.emp_cta_url_1'].defaultValue} as="span" style={{ display: 'contents' }}>
                  <EditableToken path="careersemployees.emp_cta_text_1" type="text" label="CTA 1 Text" defaultValue={contentSchema.tokens['careersemployees.emp_cta_text_1'].defaultValue} as="span" style={{ display: 'contents' }}>
                    <a className="case-btn" href={empCtaUrl1 as string} target="_blank" rel="noopener noreferrer">{empCtaText1}</a>
                  </EditableToken>
                </EditableToken>
                <EditableToken path="careersemployees.emp_cta_url_2" type="url" label="CTA 2 URL" defaultValue={contentSchema.tokens['careersemployees.emp_cta_url_2'].defaultValue} as="span" style={{ display: 'contents' }}>
                  <EditableToken path="careersemployees.emp_cta_text_2" type="text" label="CTA 2 Text" defaultValue={contentSchema.tokens['careersemployees.emp_cta_text_2'].defaultValue} as="span" style={{ display: 'contents' }}>
                    <a className="case-btn case-btn-outline" href={empCtaUrl2 as string} target="_blank" rel="noopener noreferrer">{empCtaText2}</a>
                  </EditableToken>
                </EditableToken>
              </div>
            </div>

            <div className="case-careerspage-image-grid">
              <EditableToken path="careersemployees.emp_image_0" type="image" label="Employee Image 1" defaultValue="" as="div" className="case-careerspage-image-slot">
                <VibesitesImage url={empImage0 as string} alt="" width={400} height={300} />
              </EditableToken>
              <div className="case-careerspage-image-frame">
                <img src={cornerIcon} alt="" className="prop-corner-icon prop-corner-icon--tr" aria-hidden="true" />
                <EditableToken path="careersemployees.emp_image_1" type="image" label="Employee Image 2" defaultValue="" as="div" className="case-careerspage-image-slot">
                  <VibesitesImage url={empImage1 as string} alt="" width={400} height={300} />
                </EditableToken>
              </div>
              <EditableToken path="careersemployees.emp_image_2" type="image" label="Employee Image 3" defaultValue="" as="div" className="case-careerspage-image-slot">
                <VibesitesImage url={empImage2 as string} alt="" width={400} height={300} />
              </EditableToken>
            </div>
          </div>
        </div>

        {/* We Believe section — image on left, text on right */}
        <div className="case-careerspage-employees-section" style={{ marginTop: '4rem' }}>
          <div className="case-careerspage-believe-grid">
            <div className="case-careerspage-believe-media">
              <img src={cornerIcon} alt="" className="prop-corner-icon prop-corner-icon--tl" aria-hidden="true" />
              <div className="case-careerspage-believe-img">
                <EditableToken path="careersemployees.bel_image" type="image" label="Philosophy Image" defaultValue="" as="div">
                  <VibesitesImage url={belImage as string} alt="" width={600} height={500} objectFit="cover" />
                </EditableToken>
              </div>
            </div>

            <div className="case-careerspage-employees-text">
              <EditableToken path="careersemployees.bel_label" type="text" label="Section Label" defaultValue={contentSchema.tokens['careersemployees.bel_label'].defaultValue} as="h4" style={{ fontSize: '1.125rem', fontWeight: 700, textTransform: 'uppercase', marginBottom: '0.5rem', letterSpacing: '0.05em' }}>
                {belLabel}
              </EditableToken>
              <EditableToken path="careersemployees.bel_title" type="text" label="Section Title" defaultValue={contentSchema.tokens['careersemployees.bel_title'].defaultValue} as="h2" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)', fontWeight: 700, marginBottom: '1.5rem' }}>
                {belTitle}
              </EditableToken>
              <RichTextContent
                path="careersemployees.bel_body"
                label="Body Text"
                defaultValue={contentSchema.tokens['careersemployees.bel_body'].defaultValue}
                as="div"
                style={{ lineHeight: 1.6 }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CareersEmployees',
  displayName: 'Careers Employees & Philosophy',
  tokens: {
    'careersemployees.emp_label': {
      label: 'Employees Section Label',
      type: 'text',
      defaultValue: 'OUR EMPLOYEES',
    },
    'careersemployees.emp_title': {
      label: 'Employees Section Title',
      type: 'text',
      defaultValue: 'Are what makes this company so great',
    },
    'careersemployees.emp_body': {
      label: 'Employees Body Text',
      type: 'richtext',
      defaultValue: '<p>At Case &amp; Associates, we recognize that day in and day out our employees work hard to make this a great company. Their hard work is actually the reason the red Case cube is an <a href="/awards/">industry standard for excellence</a> and makes Case the best place to live. Our goal is employee development and we believe in training our employees to not only be the best they can be, but to continually grow and promote within the company. Take a look at our open positions and contact us today so we can help you get your career started.</p>',
    },
    'careersemployees.emp_cta_text_1': {
      label: 'CTA 1 Text',
      type: 'text',
      defaultValue: 'Employee Testimonials',
    },
    'careersemployees.emp_cta_url_1': {
      label: 'CTA 1 URL',
      type: 'url',
      defaultValue: 'https://www.youtube.com/playlist?list=PLqtZ8rmM_QsH3lIA81EnPkPPyku4WAI5L',
    },
    'careersemployees.emp_cta_text_2': {
      label: 'CTA 2 Text',
      type: 'text',
      defaultValue: 'Indeed Reviews',
    },
    'careersemployees.emp_cta_url_2': {
      label: 'CTA 2 URL',
      type: 'url',
      defaultValue: 'https://www.indeed.com/cmp/Case-&-Associates',
    },
    'careersemployees.emp_image_0': {
      label: 'Employee Image 1',
      type: 'image',
      defaultValue: '',
    },
    'careersemployees.emp_image_1': {
      label: 'Employee Image 2',
      type: 'image',
      defaultValue: '',
    },
    'careersemployees.emp_image_2': {
      label: 'Employee Image 3',
      type: 'image',
      defaultValue: '',
    },
    'careersemployees.bel_label': {
      label: 'Philosophy Section Label',
      type: 'text',
      defaultValue: 'WE BELIEVE',
    },
    'careersemployees.bel_title': {
      label: 'Philosophy Section Title',
      type: 'text',
      defaultValue: 'That Each Position is Important',
    },
    'careersemployees.bel_body': {
      label: 'Philosophy Body Text',
      type: 'richtext',
      defaultValue: '<p>Our Founder &amp; CEO, Mike Case, says \u201cOur company goal is to do our jobs better than our competition and strive to be the very best at everything we do. Case &amp; Associates is committed to hiring and retaining quality employees by encouraging them, challenging them, supporting them and creating advancement opportunities for them.\u201d</p><p>Come be a part of <a href="/about-us">a loyal company</a> who values each and every employee.</p><p>We understand that it takes a village to help make our residents have the best home experience available and we believe we employ them.</p>',
    },
    'careersemployees.bel_image': {
      label: 'Philosophy Image',
      type: 'image',
      defaultValue: '',
    },
  },
};

(CareersEmployees as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default CareersEmployees;
